import { useTranslation } from 'react-i18next';

export default function ContactInfo() {
  const { t } = useTranslation();
  return (
    <div className="space-y-5">
      <div className="bg-secondary-50 rounded-xl p-6">
        <h2 className="font-heading text-xl font-bold text-secondary-900 mb-5">
          {t('contact.getInTouch')}
        </h2>

        <div className="space-y-5">
          <a
            href="tel:+84362923218"
            className="flex items-start gap-3 group"
          >
            <div className="w-10 h-10 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center shrink-0">
              <i className="ri-phone-line text-lg" />
            </div>
            <div>
              <p className="text-xs text-secondary-500 uppercase tracking-wider mb-0.5">{t('contact.callUs')}</p>
              <p className="text-sm font-semibold text-secondary-800 group-hover:text-primary-600 transition-colors">
                +84 362 923 218
              </p>
            </div>
          </a>

          <a
            href="mailto:admin@vietnam.st"
            className="flex items-start gap-3 group"
          >
            <div className="w-10 h-10 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center shrink-0">
              <i className="ri-mail-line text-lg" />
            </div>
            <div>
              <p className="text-xs text-secondary-500 uppercase tracking-wider mb-0.5">{t('contact.email')}</p>
              <p className="text-sm font-semibold text-secondary-800 group-hover:text-primary-600 transition-colors">
                admin@vietnam.st
              </p>
            </div>
          </a>

          <div className="flex items-start gap-3">
            <div className="w-10 h-10 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center shrink-0">
              <i className="ri-map-pin-line text-lg" />
            </div>
            <div>
              <p className="text-xs text-secondary-500 uppercase tracking-wider mb-0.5">{t('contact.headquarters')}</p>
              <p className="text-sm font-semibold text-secondary-800">
                {t('contact.address')}
              </p>
            </div>
          </div>

          <div className="flex items-start gap-3">
            <div className="w-10 h-10 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center shrink-0">
              <i className="ri-time-line text-lg" />
            </div>
            <div>
              <p className="text-xs text-secondary-500 uppercase tracking-wider mb-0.5">{t('contact.officeHours')}</p>
              <p className="text-sm font-semibold text-secondary-800">{t('contact.hours')}</p>
            </div>
          </div>
        </div>
      </div>

      {/* Map */}
      <div className="rounded-xl overflow-hidden border border-secondary-200">
        <iframe
          title={t('contact.mapTitle')}
          src="https://www.google.com/maps?q=Ng%C3%B5%20264%20B%E1%BB%93%20%C4%90%E1%BB%81%20Long%20Bi%C3%AAn%20H%C3%A0%20N%E1%BB%99i&output=embed"
          className="w-full h-64 md:h-72 border-0"
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>
    </div>
  );
}